import React from "react";
import { Route, Redirect, withRouter } from "react-router-dom";
import jwt_decode from "jwt-decode";

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  activeNavLink,
}) => (
  <Route
    render={(props) => {
      // if not logged in, redirect to login page

      let token = localStorage.getItem("JWT");
      let activeNavLinks = JSON.parse(localStorage.getItem("activeNaviLinks"));

      if (!token || !activeNavLinks) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }

      if (
        !activeNavLinks.includes(activeNavLink) &&
        activeNavLink !== "Occupancy" &&
        activeNavLink !== "active"
      ) {
        return <Redirect to="/occupancy" />;
      }
      return (
        <Layout>
          <Component {...props} />
        </Layout>
      );
    }}
  />
);

export default withRouter(Authmiddleware);
